import app from '../firebase';

/**
 * Converts js Date to datestring compatible with material UI
 */
export const toDateString = (d) => {
	let year = d.getFullYear();
	let month = getPaddedVal(d.getMonth() + 1);
	let day = getPaddedVal(d.getDate());
	let hour = getPaddedVal(d.getHours());
	let minute = getPaddedVal(d.getMinutes());
	return `${year}-${month}-${day}T${hour}:${minute}`;
}

/**
 * Converts from string in form:
 * 	YYYY-m-dTH:M 
 * to a JS date
 * @param {String} s date string
 */
export const fromDateString = (s) => {
	let d = new Date(s);
	return d;
}

const getPaddedVal = (v) => {
	if (v < 10){
		return `0${v}`
	}
	else{
		return `${v}`
	}
}

/**
 * Gets customer data from Firestore
 * @param {string} customerId 
 */
export const getCustomerData = async (customerId) => {
	// Setup firestore connection
	const db = app.firestore();

	// Get the locations for the customer
	let customerData = await db.collection('customer').doc(customerId).get();
	customerData = await customerData.data();
	return customerData;
}

export const getLocationDBData = async (lids, currentUser, routes) => {
	let params = JSON.stringify({ids:lids});
	let token = await currentUser.getIdToken();
	let url = routes['getLocations'];
	const r = await fetch(url, {
		method: 'POST',
		body: params,
		headers:{
			'Content-Type': 'application/JSON',
			'Authorization': `${token}`
		}
	})
	let dat = await r.json();
	
	return dat;
}


export const getCustomerLocations = async (currentUser, routes) => {
	// Get customer data (which includes their locations)
	let customerData = await getCustomerData(currentUser.uid);
	let locations = customerData.locations;

	// Hit the DB for location Name
	let locationData = await getLocationDBData(locations, currentUser, routes);
	console.log(locationData);
	return locationData;
}